<template>
	<div v-if="differenze.length" class="pd-box">
		<v-icon x-small color="warning" class="mr-1">mdi-alert-outline</v-icon>I placeholder devono essere uguali in tutte le lingue:
		<span v-for="d in differenze" :key="d.lang" class="d-block">
			<strong>{{ d.lang.toUpperCase() }}</strong> non usa {{ d.mancano.map(p => '[' + p + ']').join(', ') }}
		</span>
	</div>
</template>

<script>
import { testoPiano, placeholderUsati } from './tipologie';

// avviso quando una lingua compilata non usa tutti i placeholder delle altre
export default {
	name: 'PlaceholderDifferenze',
	props: {
		// [{ lang, oggetto, text, button }]
		traduzioni: { type: Array, default: () => [] },
	},
	computed: {
		differenze() {
			// le lingue ancora vuote le segnala già lo stato delle traduzioni
			const compilate = this.traduzioni.filter(t => testoPiano(t.text) || String(t.oggetto || '').trim());
			if (compilate.length < 2) return [];
			const tutti = [...new Set(compilate.flatMap(t => placeholderUsati(t)))];
			return compilate
				.map(t => {
					const usati = placeholderUsati(t);
					return { lang: t.lang, mancano: tutti.filter(p => !usati.includes(p)) };
				})
				.filter(d => d.mancano.length);
		},
	},
};
</script>

<style scoped>
.pd-box {
	margin-top: 4px;
	padding: 6px 8px;
	border-radius: 6px;
	background: #fff6e5;
	color: #7a4a00;
	font-size: 12px;
}
</style>
